import { Action, createReducer, on } from '@ngrx/store';

import * as DataAccessFairsActions from './data-access-fairs.actions';

import { FairsConfiguration } from '../../../interfaces/environment.interfaces';
import { Fair } from '../../../interfaces/fair.interfaces';

export const DATA_ACCESS_FAIRS_FEATURE_KEY = 'dataAccessFairs';

export interface FairsState {
  nextCursor?: string;
  fairs: KeyedFairsState;
  activeFairLoading?: boolean;
  activeFairError?: string;
  config: FairsConfiguration;
}

export interface KeyedFairsState {
  [id: string]: Fair;
}

export interface DataAccessFairsPartialState {
  readonly [DATA_ACCESS_FAIRS_FEATURE_KEY]: FairsState;
}

export const initialFairsState: FairsState = {
  fairs: {},
  config: {
    activeFair: '196',
    bauInsights: '229',
    fairs: {
      '48': { name: '', advertisements: { parallax: { enabled: false }, skyscraper: { enabled: false } } },
      '185': { name: '', advertisements: { parallax: { enabled: false }, skyscraper: { enabled: false } } },
      '196': { name: '', advertisements: { parallax: { enabled: false }, skyscraper: { enabled: false } } },
      '229': { name: '', advertisements: { parallax: { enabled: false }, skyscraper: { enabled: false } } },
    },
  },
};

const dataAccessFairsReducer = createReducer(
  initialFairsState,
  on(DataAccessFairsActions.appOpenedSucceeded, (state, { config }) => ({
    ...state,
    config,
  })),
  on(DataAccessFairsActions.fairOpened, (state, { fairId }) => {
    const loaded = typeof state.fairs[fairId] !== 'undefined';

    return {
      ...state,
      activeExhibitorLoading: !loaded,
      activeExhibitorError: undefined,
    };
  }),
  on(DataAccessFairsActions.fairLoadSucceeded, (state, { fair }) => ({
    ...state,
    activeFairLoading: false,
    fairs: {
      ...state.fairs,
      [fair.id]: fair,
    },
  })),
  on(DataAccessFairsActions.fairLoadFailed, (state, { error }) => ({
    ...state,
    activeFairError: error,
    activeFairLoading: false,
  }))
);

export function fairsReducer(state: FairsState | undefined, action: Action) {
  return dataAccessFairsReducer(state, action);
}
